/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Brew_InfusionsInputs */

const vi_shop_brew_infusions = /** @type {(inputs: Shop_Brew_InfusionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lần pha`)
};

/**

* @param {Shop_Brew_InfusionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_brew_infusions = /** @type {((inputs?: Shop_Brew_InfusionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Brew_InfusionsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_brew_infusions(inputs)
});